import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Paper, Typography, Stack, Button, Box, Alert, Snackbar } from '@mui/material';
import axiosInstance from '../utils/axiosInstance';

const ApplySentPage = () => {
    const location = useLocation();
    const { application_id, plan_id, email } = location.state || {};

    const [isResending, setIsResending] = useState(false);
    const [resent, setResent] = useState(false);
    const [cooldown, setCooldown] = useState(0);

    useEffect(() => {
        if (cooldown === 0) return;

        const timer = setInterval(() => {
            setCooldown(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [cooldown]);

    if (!application_id || !plan_id || !email) {
        return <Box sx={{ textAlign: 'center', mt: 10 }}>ページ情報が正しくありません。</Box>;
    }

    const maskEmail = (email = '') => {
        if (!email.includes('@')) return email;
        const [name, domain] = email.split('@');
        return `${name.slice(0, 2)}***@${domain}`;
    };

    const handleResend = async () => {
        if (!email || cooldown > 0) return;

        try {
            setIsResending(true);

            await axiosInstance.post('/resend', { application_id });

            setResent(true);
            setCooldown(60);
        } finally {
            setIsResending(false);
        }
    };

    return (
        <Box sx={{ maxWidth: 520, mx: 'auto' }}>
            <Typography component="h1" variant="h2" textAlign="center" mb={2}>
                無料トライアル申請を受け付けました
            </Typography>

            <Alert severity="info" sx={{ mb: 2 }}>
                <Typography variant="body2">
                    ご入力いただいたメールアドレス宛に、アカウント登録用のリンクをお送りしました。
                    メール内のリンクをクリックして、アカウント作成を完了してください。
                </Typography>
            </Alert>

            <Paper variant="section" sx={{ p: 3 }}>
                <Stack spacing={3} alignItems="center">
                    {email && (
                        <Typography variant="h6" color="text.secondary">
                            {maskEmail(email)}
                        </Typography>
                    )}

                    <Button
                        variant="outlined"
                        onClick={handleResend}
                        disabled={isResending || cooldown > 0}
                    >
                        {isResending
                            ? '再送信中…'
                            : cooldown > 0
                                ? `再送信まで ${cooldown} 秒`
                                : 'メールを再送信'}
                    </Button>

                    <Typography variant="body2" color="text.secondary" textAlign="center">
                        ※ 数分経っても届かない場合は、迷惑メールフォルダをご確認ください。
                    </Typography>
                </Stack>
            </Paper>

            <Snackbar
                open={resent}
                autoHideDuration={3000}
                onClose={() => setResent(false)}
            >
                <Alert severity="success" sx={{ width: '100%' }}>
                    メールを再送信しました
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default ApplySentPage;